[
  {
    "data_types": ["name", "password", "phone number", "payment information", "email address"],
    "category": "Account Information",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [18, 19, 20, 387, 388],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 172, 173, 174, 175, 176, 177, 178, 179, 462],
        "certainty": "high"
      },
      {
        "reason": "Process transactions or payments",
        "evidence": [176, 177, 489, 490, 491],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [140, 141, 142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [125, 126, 127, 128, 129, 330, 331, 332, 333, 334],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": ["photos", "videos", "emails", "docs", "spreadsheets", "comments"],
    "category": "User-Generated Content",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [22, 23, 45, 175, 178, 179, 462],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [47, 50, 51, 52, 203, 204, 205, 206, 207, 208],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [53, 54, 55, 56, 57, 58, 255, 256, 257, 258],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [140, 141, 142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      },
      {
        "party": "General public",
        "evidence": [113, 114, 115, 116],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "unique identifiers",
      "browser type and settings",
      "device type and settings",
      "operating system",
      "mobile network information",
      "application version number",
      "IP address",
      "crash reports",
      "system activity",
      "referrer URL"
    ],
    "category": "Device and Browser Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [24, 25, 26, 27, 28, 29, 45, 173, 174, 462],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [69, 70, 71, 72, 73, 74, 75, 323, 324, 325],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [47, 203, 204, 205, 206, 207, 208, 209, 210, 211],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [143, 144],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [125, 126, 127, 128, 129, 330, 331, 332, 333, 334],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "search terms",
      "videos watched",
      "views and interactions with content and ads",
      "Chrome browsing history",
      "activity on third-party sites and apps"
    ],
    "category": "Activity Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [30, 45, 172, 173, 174, 175, 176, 177, 178, 179],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [47, 50, 51, 52, 203, 204, 205, 206, 207, 208],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [53, 54, 55, 56, 57, 58, 255, 256, 257, 258],
        "certainty": "high"
      },
      {
        "reason": "Measurement and analytics",
        "evidence": [60, 61, 62, 63, 64, 277, 278, 279, 280, 281],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [140, 141, 142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Advertisers",
        "evidence": [62, 63, 64, 255, 256, 257, 258, 259, 277, 278],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "GPS and other sensor data",
      "IP address",
      "activity on Google services",
      "information about things near your device"
    ],
    "category": "Location Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [33, 34, 35, 36, 37, 38, 39, 45, 172, 173],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [47, 50, 51, 52, 203, 204, 205, 206, 207, 208],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [53, 54, 55, 56, 57, 58, 255, 256, 257, 258],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [140, 141, 142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Advertisers",
        "evidence": [62, 63, 64, 255, 256, 257, 258, 259, 277, 278],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["information from publicly accessible sources", "information from trusted partners"],
    "category": "Third-Party Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [40, 41, 42, 43, 180, 181, 182, 192, 193, 229],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [47, 203, 204, 205, 206, 207, 208, 209, 210, 211],
        "certainty": "high"
      },
      {
        "reason": "Train Machine Learning or AI models",
        "evidence": [229, 230, 242, 244, 245],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [143, 144],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "call and message log information",
      "phone number",
      "calling-party number",
      "receiving-party number",
      "forwarding numbers",
      "sender and recipient email address",
      "time and date of calls and messages",
      "duration of calls",
      "routing information",
      "types and volumes of calls and messages"
    ],
    "category": "Communication Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [31, 45, 172, 173, 174, 175, 176, 177, 178, 179],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [47, 203, 204, 205, 206, 207, 208, 209, 210, 211],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [140, 141, 142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "height",
      "weight",
      "sleep patterns",
      "heart rate",
      "skin temperature",
      "calories burned",
      "steps taken"
    ],
    "category": "Health and Fitness Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [522, 523],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [47, 203, 204, 205, 206, 207, 208, 209, 210, 211],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [140, 141, 142],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [122, 123, 124],
        "certainty": "high"
      }
    ],
    "sensitive": "sensitive"
  }
]
